module.exports = __webpack_public_path__ + "img/close@2x.7affbc16.svg";